// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "option-18bP5";
export { _1 as "__esModule", _2 as "option" }
export default { "__esModule": _1, "option": _2 }
